import BetasiNewsletter from "./BetasiNewsletter";
import ZuuInternal from "./ZuuInternal/ZuuInternal";

export default {
    "betasi-newsletter": BetasiNewsletter,
    "zuu-internal": ZuuInternal,
};
